import { router } from '@inertiajs/react'

import { Link } from '@atoms'
import { MultiSelectField } from '@components/molecules/MultiSelectField'
import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('shared.group_filter')

export type CallsGroup = { id: string; name: string }

export type CallsGroupFilterProps = {
  groups: CallsGroup[]
  groupIds: string[]
  onLoadingChange: (loading: boolean) => void
}

export const showCallsGroups = (groups: CallsGroup[], groupIds: string[]) => groups.length > 1 || groupIds.length > 0

// The one group the filter is set to, for copy that names it.
export const selectedCallsGroup = (groups: CallsGroup[], groupIds: string[]) =>
  groupIds.length === 1 ? groups.find((group) => group.id === groupIds[0]) : undefined

export const CallsGroupFilter = ({ groups, groupIds, onLoadingChange }: CallsGroupFilterProps) => (
  <div className="tw:w-full tw:pb-6 tw:sm:w-40">
    <MultiSelectField
      label={t('group')}
      placeholder={t('all_groups')}
      options={groups.map((group) => ({ value: group.id, label: group.name }))}
      value={groupIds}
      onValueChange={(next) =>
        router.get(
          window.location.pathname,
          { filter_group_ids: next },
          {
            preserveState: true,
            replace: true,
            onStart: () => onLoadingChange(true),
            onFinish: () => onLoadingChange(false),
          }
        )
      }
      selectedLabel={(selected) =>
        selected.length === 1 ? selected[0].label : t('selected_count', { count: selected.length })
      }
      searchPlaceholder={t('search')}
      noResultsText={t('none')}
      showSelectedPills={false}
    />
  </div>
)

export const ShowAllGroupsLink = () => (
  <Link as="inertiaLink" href={window.location.pathname} rank="secondary">
    {t('show_all')}
  </Link>
)
